export function queryElement<T extends Element>(selector: string, root: HTMLElement | Document = document): T | null {
    return root.querySelector(selector)
}

export function requireElement<T extends Element>(selector: string, root: HTMLElement | Document = document): T {
    const element = root.querySelector(selector) as T | null

    if (!element) {
        throw new Error(`Required element not found: ${selector}`)
    }

    return element
}
